//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
import { NsIcon } from '@nuskin/ns-icon';
import NsSlottedDropdownModal from './NsSlottedDropdownModal.vue';
import NsSlottedDropdownItems from './NsSlottedDropdownItems.vue';

/**
 * NsSlottedDropdown
 *
 * How to use: slot in a list of dom elements and listen to 'select' event.
 * Event contains '(value, index)'. 'value' will be index unless 'data-value'
 * attribute is used on root of each list element
 *
 * @event select  When a selection occurs this event emits a function with
 * params: (value, index)
 */
export default {
  name: 'NsSlottedDropdown',
  components: { NsIcon, NsSlottedDropdownModal, NsSlottedDropdownItems },
  model: {
    prop: 'selected',
    event: 'select',
  },
  props: {
    /**
     * Runs validation after closing the dropdown
     */
    autovalidate: Boolean,
    /**
     * List items have a smaller height
     */
    denseList: Boolean,
    /**
     * Sets the dropdown to disabled
     */
    disabled: Boolean,
    /**
     * Error message. Will show if truthy.
     */
    errorMessage: {
      type: String,
      default: '',
    },
    /**
     * By default the error message will be absolute-position, use this to override.
     */
    errorNoAbsolute: Boolean,
    /**
     * Label is inline
     */
    inlineLabel: Boolean,
    /**
     * Label copy for the dropdown
     */
    label: {
      type: String,
      default: '',
    },
    /**
     * Shows placeholder no matter the selection
     */
    lockPlaceholder: Boolean,
    /**
     * Uses smaller font
     */
    multiLine: Boolean,
    /**
     * Placeholder text
     */
    placeholder: {
      type: String,
      default: '',
    },
    /**
     * The error message shown when the input is invalid and required
     */
    requiredMessage: {
      type: String,
      default: 'Please choose an item.',
    },
    /**
     * Either the index or the value (data-value attribute) of the item that
     * should be in selected state
     */
    selected: {
      type: [String, Number],
      default: '',
    },
    /**
     * Shows the entire menu (no scroll)
     */
    showAll: Boolean,
    /**
     * Shows the 'custom' slot instead of 'selectedHtml' for the selected item
     */
    showCustomSelectedItem: Boolean,
    /**
     * The size of the selector. Options are 'large' and 'small'
     */
    size: {
      type: String,
      default: 'large',
    },
    /**
     * There are designs with a taller dropdown with button next to it
     */
    tall: Boolean,
    /**
     * Translations
     */
    translations: {
      type: Object,
      default() {
        return {};
      },
    },
    /**
     * Sets width of dropdown (excluding label). Alternate option is to use css
     * width on component (includes label).
     */
    width: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      /**
       * Set to true if you want to show the error message
       */
      invalid: false,
      /**
       * State of the content box. Use toggle() or close() to set this value
       */
      opened: false,
      /**
       * If true, the dropdown will open upwards
       */
      openUp: false,
      /**
       * True as long as the dropdown has never been opened. As soon as the user
       * opens the dropdown once this becomes false.
       */
      pristine: true,
      /**
       * Holds html of which dropdown item was selected
       */
      selectedHtml: null,
      /**
       * Holds actual selected value, whether from parent or dropdown
       */
      selectedValue: this.selected || '',
      /**
       * Uses modal instead of dropdown for selection when mobile
       */
      useModal: this.isMobileDevice(),
    };
  },
  computed: {
    selectedEmpty() {
      return this.selected == null || this.selected === '';
    },
    localWidth() {
      if (this.width) {
        return +this.width ? this.width + 'px' : this.width;
      }
      return null;
    },
  },
  watch: {
    selected(value) {
      this.selectedValue = value;
      if (this.autovalidate && !this.pristine) {
        this.validate();
      }
    },
    selectedValue: {
      immediate: true,
      async handler(value) {
        if (!value) {
          return;
        }

        await this.$nextTick();
        if (this.useModal) {
          this.selectedHtml = this.$refs.modal
            ? (this.$refs.modal.querySelector(`[data-value="${value}"]`) || {})
                .outerHTML
            : null;
        } else {
          this.selectedHtml = this.$refs.list
            ? (this.$refs.list.querySelector(`[data-value="${value}"]`) || {})
                .outerHTML
            : null;
        }
      },
    },
  },
  methods: {
    /**
     * Reset the dropdown to an unselected/initial state
     */
    clear() {
      // Clear the values and text
      this.selectedValue = '';
      this.emitSelect('');
    },
    /**
     * Closes the dropdown/modal and validates if necessary
     */
    close() {
      this.opened = false;
      if (this.autovalidate && !this.pristine) {
        this.validate();
      }
    },
    /**
     * Close the dropdown content container
     */
    closeDropdown() {
      if (!this.useModal) {
        this.close();
      }
    },
    /**
     * Emits an event whenever an item is selected
     */
    emitSelect(value, index) {
      /**
       * Fired when a menu item is selected: function(value: string|number, index: number) => void
       *
       * @type {select}
       * @property {(string|number)} value data-value attribute of the selected item, or index
       * @property {number} index index of the selected item
       */
      this.$emit('select', value, index);
    },
    /**
     * Sets the selection
     */
    handleSelect(value, index) {
      this.emitSelect(value, index);
      if (value !== 'custom') {
        this.selectedValue = value;
        this.emitSelect(value, index);
        this.close();
      }
    },
    /**
     * Checks if device is mobile (will use modal if so)
     */
    isMobileDevice() {
      return (
        typeof window.orientation !== 'undefined' ||
        navigator.userAgent.includes('IEMobile')
      );
    },
    /**
     * Show errors if invalid. This is used by ns-form for showing or clearing
     * out errors.
     */
    showErrors() {
      this.validate();
    },
    /**
     * Opens and closes the content area if not disabled.
     */
    toggle() {
      if (!this.disabled) {
        // if opening, check whether to open up or down
        if (!this.opened) {
          const clientY = this.$refs.nsSlottedDropdown.getBoundingClientRect()
            .top;
          this.openUp = clientY > window.innerHeight / 2;
        }

        this.opened = !this.opened;
        this.pristine = false;

        if (this.autovalidate && !this.opened) {
          this.validate();
        }
        if (this.useModal && document.activeElement) {
          document.activeElement.blur();
        }
      }
    },
    /**
     * Simple validation to see if anything was selected or not
     */
    validate() {
      if (this.selectedEmpty) {
        this.invalid = true;
      } else {
        this.invalid = false;
      }
      return !this.invalid;
    },
  },
};
